import React, { useEffect, useRef, useState } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { useTexture } from "@react-three/drei";
import { useSelector } from "react-redux";

const RainyTheme = ({ radius }) => {
  const areThemesHidden = useSelector(
    (state) => state.configurator.areThemesHidden
  );

  const [dropParticles, setDropParticles] = useState(false);

  const ref = useRef();
  const texture = useTexture("/rain_drop.png");

  const numParticles = 800 * radius;
  const particles = new Float32Array(numParticles * 3);

  useEffect(() => {
    for (let i = 0; i < particles.length; i += 3) {
      particles[i] = (Math.random() - 0.5) * radius;
      particles[i + 1] = (Math.random() - 0.5) * 5;
      particles[i + 2] = (Math.random() - 0.5) * radius;
    }
    setDropParticles(true);
  }, [particles]);

  useEffect(() => {
    if (areThemesHidden) setDropParticles(false);
  }, [areThemesHidden]);

  useFrame((state, delta) => {
    if (dropParticles) {
      for (let i = 0; i < particles.length; i += 3) {
        particles[i + 1] -= delta * 3; // Adjust the falling speed (lower values = slower)

        if (particles[i + 1] < -3) {
          particles[i + 1] = 1; // Reset the particle to the top when it falls below the radius
        }
      }
      ref.current.geometry.attributes.position.needsUpdate = true;
    }
  });

  return (
    <points ref={ref}>
      <bufferGeometry attach="geometry">
        <bufferAttribute
          attach="attributes-position"
          count={numParticles}
          array={particles}
          itemSize={3}
        />
      </bufferGeometry>
      <pointsMaterial
        attach="material"
        size={0.02} // Adjust the size of the particles
        map={texture}
        depthWrite={false} // Set to false to avoid rendering particles in a specific order
        blending={THREE.AdditiveBlending} // Use additive blending for better particle effects
      />
    </points>
  );
};

export default RainyTheme;
